import { render, staticRenderFns } from "./EditPayPalPaymentConfig.vue?vue&type=template&id=0be54da6&"
import script from "./EditPayPalPaymentConfig.vue?vue&type=script&lang=ts&"
export * from "./EditPayPalPaymentConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports